import { FaChevronDown } from 'react-icons/fa';
// this is bad because its an invisible and unintuitive div wrapper
export default function CoorpHero({
  headingOne,
  headingTwo,
  headingThree,
}: {
  headingOne: string;
  headingTwo: string;
  headingThree: string;
  innerImage?: string;
}) {
  return (
    <div className='text-white'>
      <div className=''>
        <div className='pl-3'>
          <h1 className='pb-5 text-3xl font-bold text-white'>{headingOne}</h1>
        </div>
        <div className='pl-3'>
          <h2 className='mb-10 text-xl font-normal text-white'>{headingTwo}</h2>
        </div>
        <div className='relative h-48 bg-brand-500'>
          <h3 className='absolute left-1/2 top-1/2 w-full -translate-x-1/2 -translate-y-1/2 px-4 text-center font-normal text-white'>
            {headingThree}
          </h3>
          <div />
          <div className='absolute bottom-2 left-1/2'>
            <ScrollDownArrow />
          </div>
        </div>
      </div>
    </div>
  );
}

function ScrollDownArrow() {
  function scrollDownABit() {
    // scroll a bit down smoothly
    window.scroll({
      top: window.innerHeight - 350,
      left: 0,
      behavior: 'smooth',
    });
  }
  return (
    <div className='animate-pulse'>
      <FaChevronDown onClick={scrollDownABit} />
    </div>
  );
}
